module.exports = __webpack_public_path__ + "img/T1D_rc-17.312aed3b.png";